module.exports = __webpack_public_path__ + "img/GQ.78c876ee.png";